import { render, staticRenderFns } from "./InnerQuotaMonthRatio.vue?vue&type=template&id=17a757f1&scoped=true&"
import script from "./InnerQuotaMonthRatio.vue?vue&type=script&lang=js&"
export * from "./InnerQuotaMonthRatio.vue?vue&type=script&lang=js&"
import style0 from "./InnerQuotaMonthRatio.vue?vue&type=style&index=0&id=17a757f1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a757f1",
  null
  
)

export default component.exports